const BaseUrl = {
	dataBase: process.env.REACT_APP_DATABASE || "BD50",
	multiTenant: process.env.REACT_APP_MULTI_TENANT_URL || "http://localhost:11126",
	urlAsaas: process.env.REACT_APP_URL_ASAAS || "http://localhost:11128",
	whatsApp: process.env.REACT_APP_WHATSAPP_URL || "http://localhost:11130",
	// mesmo servidor do whatsApp (Servidor Cobranca), com o nome do dominio
	cobranca: process.env.REACT_APP_COBRANCA_URL || process.env.REACT_APP_WHATSAPP_URL || "http://localhost:11130",
	email: process.env.REACT_APP_EMAIL_URL || "http://localhost:11587",
	billing: process.env.REACT_APP_BILLING_URL || "http://localhost:11134",
	aiServer: process.env.REACT_APP_AI_SERVER_URL || "http://localhost:3005",
	webhook: process.env.REACT_APP_WEBHOOK_URL || "http://localhost:3006",
};

export default BaseUrl;
